import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        imported_data: {
          header: 'HEADER',
          aasm_state: {
            downloaded: 'DOWNLOADED',
            processing: 'PROCESSING',
            parsed: 'PARSED',
            error: 'ERROR',
          },
        },
      },
    },
  }));
}
